import common from '@page/common/js/common';
import Selector from '@page/common/js/template/select';

import INDEX_TMPL from '@page/shopContent/js/indexTmpl';

import Photo from '@page/shopContent/components/Photo.vue';
import Spec from '@page/shopContent/components/Spec.vue';
import CartDialog from '@page/shopContent/components/CartDialog.vue';
import AddonShop from '@page/shopContent/components/AddonShop.vue';
import SizeChart from '@page/shopContent/components/SizeChart.vue';
import Recommend from '@page/shopContent/components/Recommend.vue';
import ArrivalNotice from '@page/shopContent/components/ArrivalNotice.vue';

import Vue from 'vue';
import axios from 'axios';
import AlertDialog from '@global/helpers/alertDialog';
import store from '@global/components/store/index';
import { fireShopContentView } from '@global/gtm/product';

require('@global/vendors/jquery.sticky-kit');

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

const app = new Vue({
  el: '#shop-content',
  components: {
    Spec,
    SizeChart,
    Photo,
    Recommend,
    ArrivalNotice,
    Selector,
    CartDialog,
    AddonShop,
  },
  data: {
    itemDatas: {},
    selectedDataID: null,
    selectedData: {},
    dataIsLoad: false,
    nowSlideIndex: 0,
    hasStock: false,
    CMID: null,
    changePic: false,
  },
  watch: {
    selectedDataID() {
      this.getSelectedData();

      fireShopContentView({
        affiliation: this.selectedData.Name,
        customMarketID: window.CustomMarketID,
        eventName: this.itemDatas.Events.length ? this.itemDatas.Events[0].Name : '',
        name: this.itemDatas.Name,
        price: this.itemDatas.SellPrice_TW,
      });
    },
  },
  created() {
    axios
      .get(API_URL.MARKET_CONTENT, {
        params: {
          CustomMarketID: window.CustomMarketID,
        },
      })
      .then((res) => {
        if (res.data.Code === 200) {
          this.dataIsLoad = true;
          this.itemDatas = res.data.Response;
          this.selectedDataID = res.data.Response.ColorID;
        } else {
          AlertDialog.alert('系統忙線中,請稍後再試', () => {
            window.location.href = '/';
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    handleCMID(val) {
      this.CMID = val;
    },
    checkHasStock() {
      this.hasStock = false;
      this.selectedData.Specs.forEach((element, index) => {
        if (parseInt(element.Stock) !== 0) {
          this.hasStock = true;
        }
      });
    },
    changeSelected(val) {
      this.selectedDataID = val;
      this.changePic = true;
    },
    changeNowSlideIndex(val) {
      this.nowSlideIndex = val;
    },
    getSelectedData() {
      this.itemDatas.Colors.forEach((element) => {
        if (element.ID === this.selectedDataID) {
          this.selectedData = element;
        }
      });
      this.checkHasStock();
    },
  },
  template: INDEX_TMPL,
  store,
});

$(document).on('click', '.open-dialog', function (e) {
  e.preventDefault();
  const $el = $(this);
  const elCustomMarketID = $el.data('custommarketid');

  axios
    .get(API_URL.MARKET_CONTENT, {
      params: {
        CustomMarketID: elCustomMarketID,
      },
    })
    .then((res) => {
      if (res.data.Code === 200) {
        app.$refs.c_favorite.isOpen = true;
        app.$refs.c_favorite.allData = res.data.Response;
        app.$refs.c_favorite.selectedID = res.data.Response.ColorID;
        app.$refs.c_favorite.dataIsLoad = true;
      } else {
        AlertDialog.alert('系統忙線中,請稍後再試');
      }
    })
    .catch(() => {});
});
